<app-document-subheader></app-document-subheader>
<div class="details-content container-fluid h-100">
  <div class="row h-100">
    <div class="col-content d-flex flex-column h-100">
      <div class="page-container">
        <div class="card card-light w-100">
          <div class="card-body">
            <div class="container-fluid">
              <app-car-reference-exact-model-form-content />
            </div>
          </div>
        </div>
      </div>
    </div>
    @if (this.carReferenceExactModelId) {
      <div class="col-comment">
        <app-comment-panel
          [entityType]="'CarReferenceExactModel'"
          [entityId]="this.carReferenceExactModelId.toString()"
        ></app-comment-panel>
      </div>
    }
  </div>
</div>
